import React from 'react';

const ErrorMessage = ({ error, onRetry }) => {
  return (
    <div style={{
      background: 'rgba(239, 68, 68, 0.1)',
      border: '1px solid rgba(239, 68, 68, 0.3)',
      borderRadius: '12px',
      padding: '1.5rem',
      margin: '1rem 0',
      color: '#fca5a5'
    }}>
      <div style={{ 
        fontWeight: '600', 
        marginBottom: '0.5rem',
        color: '#ef4444'
      }}>
        ⚠ Error
      </div>
      <div style={{ marginBottom: onRetry ? '1rem' : 0 }}>
        {error}
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: '0.5rem 1rem',
            borderRadius: '6px',
            border: '1px solid rgba(239, 68, 68, 0.5)',
            background: 'rgba(239, 68, 68, 0.1)',
            color: '#fca5a5',
            fontSize: '0.875rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = 'rgba(239, 68, 68, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(239, 68, 68, 0.1)';
          }}
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;

